import routes from "../../routes";
import { applicationOverviewRoutes, detailedFinanceRoutes } from "../../constants";

export const checkIsShowSmallBg = pathname =>
  [
    routes.financeProductComparison,
    routes.comeBackLogin,
    routes.comeBackLoginVerification,
    routes.MyApplications
  ].includes(pathname);

export const checkIsShowSmallMenu = pathname =>
  ![routes.login, ...detailedFinanceRoutes, ...applicationOverviewRoutes].includes(pathname);
